import { z } from 'zod'
import { baseProjectSchema } from '../../input/project-schema'
import { filterableStateSchema } from '../base'

// -------------------------
// Projects State Validation
// -------------------------
export const projectStateItemSchema = z.object({
  ...baseProjectSchema.shape,
  isSelected: z.boolean().optional(),
  startDate: z.string().nullable(),
  endDate: z.string().nullable(),
  publishedAt: z.string().nullable(),
  vehicleId: z.string().nullable(),
  media: z.array(z.object({
    id: z.string(),
    url: z.string(),
    type: z.string(),
    mimeType: z.string(),
    size: z.number(),
    placement: z.string(),
    altText: z.string().nullable(),
    caption: z.string().nullable(),
    dpi: z.number().nullable(),
    originalName: z.string().optional().nullable(),
    width: z.number().nullable(),
    height: z.number().nullable(),
    createdAt: z.string(),
    updatedAt: z.string()
  })).optional().default([])
})

export const projectStateSchema = z.object({
  ...filterableStateSchema.shape,
  items: z.array(projectStateItemSchema),
  selectedProject: projectStateItemSchema.nullable()
})

export const projectActionValidation = {
  'projects/setProjects': z.array(projectStateItemSchema),
  'projects/updateProject': projectStateItemSchema,
  'projects/setSelectedProject': projectStateItemSchema
} as const

// Type inference helpers
export type ProjectStateValidation = z.infer<typeof projectStateSchema>
